__turbopack_context__.v({
  "plus-icon": "PlusIcon-module-scss-module__IXgoiW__plus-icon",
});
